import { ApiService } from '@services/api';
import { API_DOMAIN } from '@constants/api';
import {
  IGetCredentialProps,
  ICreateCredentialProps,
  IUpdateCredentialProps,
  IGenerateURLProps,
} from '@domain/interfaces/dashboard/IntegrationCenter/InfoProduct/Platforms/IEduzzAuth';

export class EduzzService {
  private readonly apiService: ApiService;

  constructor(baseURL: string) {
    this.apiService = new ApiService(baseURL);
  }

  public getCredential({ storeAliasId }: IGetCredentialProps): Promise<any> {
    return this.apiService.get(`/api/v1/users/stores/${storeAliasId}/eduzz-credentials`);
  }

  public createCredential({ storeAliasId, data }: ICreateCredentialProps): Promise<any> {
    return this.apiService.post(`/api/v1/users/stores/${storeAliasId}/eduzz-credentials`, {
      ...data,
    });
  }

  public updateCredential({
    storeAliasId,
    credentialAliasId,
    data,
  }: IUpdateCredentialProps): Promise<any> {
    return this.apiService.put(
      `/api/v1/users/stores/${storeAliasId}/eduzz-credentials/${credentialAliasId}`,
      {
        ...data,
      },
    );
  }

  public generateWebhookURL({ storeAliasId }: IGenerateURLProps): Promise<any> {
    return this.apiService.post(
      `/api/v1/users/stores/${storeAliasId}/eduzz-credentials/generate-webhook-url`,
    );
  }
}

const eduzzService = new EduzzService(API_DOMAIN);

export default eduzzService;
